import { render, staticRenderFns } from "./dingding.vue?vue&type=template&id=0614f4f7&scoped=true"
import script from "./dingding.vue?vue&type=script&lang=js"
export * from "./dingding.vue?vue&type=script&lang=js"
import style0 from "./dingding.vue?vue&type=style&index=0&id=0614f4f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0614f4f7",
  null
  
)

export default component.exports